// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3NjXZ","buttons":"RemoveExpirationActionButtons_buttons__2rm4C"};